import { Button, Grid } from "@mui/material";
import {
  BooleanField,
  NumberField,
  processStateOptions,
  SelectField,
  TextField,
  useStudioForm,
  WorkflowSelect,
} from "~/components/Form";
import { AuditFilters } from "~/domain/auditable";
import type { ListIngestionPartsFormValues } from "../schemas";
import { listIngestionPartsSchema } from "../schemas";

export interface IngestionPartFiltersProps {
  values: ListIngestionPartsFormValues;
  setValues: (newValues: ListIngestionPartsFormValues) => void;
}

export function IngestionPartFilters({
  values,
  setValues,
}: IngestionPartFiltersProps) {
  const { control, handleSubmit } = useStudioForm({
    schema: listIngestionPartsSchema,
    values,
    onSubmit: setValues,
  });

  return (
    <Grid container spacing={2} component="form" onSubmit={handleSubmit}>
      <Grid item xs={3}>
        <NumberField control={control} name="sequence" />
      </Grid>
      <Grid item xs={3}>
        <TextField control={control} name="source" />
      </Grid>
      <Grid item xs={3}>
        <WorkflowSelect control={control} name="workflowId" />
      </Grid>
      <Grid item xs={3}>
        <BooleanField control={control} name="workflowIdNull" />
      </Grid>
      <Grid item xs={3}>
        <SelectField
          control={control}
          name="state"
          options={processStateOptions}
        />
      </Grid>
      <AuditFilters control={control} />
      <Grid item xs={12}>
        <Button type="submit" variant="contained">
          Filter
        </Button>
      </Grid>
    </Grid>
  );
}
